<template>
  <!-- 最后X天按钮组 组件 -->
  <!-- 
    调用时需要参数 ：
    1. :value : 数字数组，最后X天选项数组
    2. @get-data : 获取数据方法，修改选项后自动触发
  -->

  <div class="last-btn-group">
    <div
      v-for="(item, index) in daysList"
      :key="item"
      :class="{
        'last-btn': true,
        'last-btn-active': index === activeIndex,
        'last-btn-unactive': index !== activeIndex,
      }"
      @click="handleChangeOption(item)"
    >
      <span v-if="item === 1">Today</span>
      <span v-else>Last {{ item }} days</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LastXDays',
  props: {
    daysList: {
      type: Array,
      default: () => {
        return [7, 30]
      },
    },
  },

  data() {
    return {
      value: this.daysList[0],
    }
  },
  computed: {
    activeIndex() {
      return this.daysList.indexOf(this.value)
    },
  },
  methods: {
    handleChangeOption(value) {
      this.value = value
      this.$emit('update:value', value)
      this.$emit('get-data')
    },
  },
}
</script>

<style lang="scss" scoped>
.last-btn-group {
  display: flex;
  text-align: center;
  user-select: none;

  .last-btn {
    margin-left: 10px;
    line-height: 30px;
    border-radius: 4px;
    border: 1px solid #2486df;
    padding: 0 5px;

    &:hover {
      cursor: pointer;
    }
  }

  .last-btn:first-child {
    margin-left: 0;
  }

  .last-btn-active {
    color: #fff;
    background-color: #2486df;
  }

  .last-btn-unactive {
    color: #333;
    background-color: #fff;
    &:hover {
      color: #2486df;
    }
  }
}
</style>
